import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const isFor = ['Dueños de gatos que viven en departamentos o espacios reducidos.', 'Personas que sufren de insomnio o irritabilidad por interrupciones del sueño.', 'Inquilinos que temen problemas con el consorcio por ruidos molestos.', 'Padres de gatos que quieren una solución ética y natural, sin fármacos.'];
const isNotFor = ['Personas que buscan una "pastilla mágica" para sedar a su mascota.', 'Dueños que no están dispuestos a dedicar 20 minutos de juego al llegar a casa.', 'Casos de gatos con patologías médicas graves (en ese caso, consultá a un vet).'];
export function ForNotFor() {
  return <section className="py-16 sm:py-24 bg-navy-light/30 border-y border-white/5" data-id="element-195">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-196">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-197">
          {/* Is For */}
          <div data-id="element-198">
            <FadeIn data-id="element-199">
              <h3 className="text-2xl sm:text-3xl font-bold mb-8 text-slate-100 flex items-center gap-3" data-id="element-200">
                <span className="bg-green-500/10 text-green-400 p-2 rounded-lg" data-id="element-201">
                  <CheckCircleIcon className="h-6 w-6" data-id="element-202" />
                </span>
                Esto es para vos si...
              </h3>
              <ul className="space-y-4" data-id="element-203">
                {isFor.map((item, index) => <li key={index} className="flex gap-3 text-slate-300 font-sans" data-id="element-204">
                    <CheckCircleIcon className="h-6 w-6 text-green-500/70 shrink-0" data-id="element-205" />
                    <span data-id="element-206">{item}</span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>

          {/* Is Not For */}
          <div data-id="element-207">
            <FadeIn delay={0.2} data-id="element-208">
              <h3 className="text-2xl sm:text-3xl font-bold mb-8 text-slate-100 flex items-center gap-3" data-id="element-209">
                <span className="bg-red-500/10 text-red-400 p-2 rounded-lg" data-id="element-210">
                  <XCircleIcon className="h-6 w-6" data-id="element-211" />
                </span>
                Esto NO es para vos si...
              </h3>
              <ul className="space-y-4" data-id="element-212">
                {isNotFor.map((item, index) => <li key={index} className="flex gap-3 text-slate-400 font-sans" data-id="element-213">
                    <XCircleIcon className="h-6 w-6 text-red-500/50 shrink-0" data-id="element-214" />
                    <span data-id="element-215">{item}</span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}